import React from "react";

const ImageCaptionIcon = ({ color, size }) => {
  return (
    <svg
      width={size ?? "20"}
      height={size ?? "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.25 3C1.25 1.96447 2.08947 1.125 3.125 1.125H16.875C17.9105 1.125 18.75 1.96447 18.75 3V13C18.75 14.0355 17.9105 14.875 16.875 14.875H3.125C2.08947 14.875 1.25 14.0355 1.25 13V3ZM2.5 11.3839V13C2.5 13.3452 2.77982 13.625 3.125 13.625H16.875C17.2202 13.625 17.5 13.3452 17.5 13V11.3839L15.2589 9.14277C14.7707 8.65461 13.9793 8.65461 13.4911 9.14277L12.7589 9.875L13.5669 10.6831C13.811 10.9271 13.811 11.3229 13.5669 11.5669C13.3229 11.811 12.9271 11.811 12.6831 11.5669L8.38388 7.26777C7.89573 6.77961 7.10427 6.77961 6.61612 7.26777L2.5 11.3839ZM10.9375 4.875C10.9375 4.35723 11.3572 3.9375 11.875 3.9375C12.3928 3.9375 12.8125 4.35723 12.8125 4.875C12.8125 5.39277 12.3928 5.8125 11.875 5.8125C11.3572 5.8125 10.9375 5.39277 10.9375 4.875Z"
        fill={color ?? "#149DFF"}
      />
      <path
        d="M3.28214 19.0553C2.56814 19.0553 1.99414 18.5408 1.99414 17.7673C1.99414 16.9938 2.58214 16.4688 3.27514 16.4688C4.02064 16.4688 4.34964 16.9483 4.43014 17.3053L3.90864 17.4698C3.87014 17.2983 3.71264 17.0077 3.27514 17.0077C2.94264 17.0077 2.56814 17.2458 2.56814 17.7673C2.56814 18.2328 2.91114 18.5023 3.28214 18.5023C3.71264 18.5023 3.88414 18.2153 3.93314 18.0368L4.46164 18.1873C4.38114 18.5303 4.05214 19.0553 3.28214 19.0553Z"
        fill={color ?? "#149DFF"}
      />
      <path
        d="M6.38413 19.0028L6.20563 18.4988H5.24662L5.06813 19.0028H4.48712L5.42163 16.5212H6.06213L6.98612 19.0028H6.38413ZM5.73312 17.1372L5.42863 17.9948H6.03063L5.73312 17.1372Z"
        fill={color ?? "#149DFF"}
      />
      <path
        d="M7.84844 17.6343H8.17044C8.38044 17.6343 8.52394 17.5117 8.52394 17.3192C8.52394 17.1197 8.38044 17.0008 8.17044 17.0008H7.84844V17.6343ZM8.22644 18.1102H7.84494V19.0028H7.29194V16.5212H8.22644C8.73044 16.5212 9.07694 16.8538 9.07694 17.3158C9.07694 17.7848 8.73044 18.1102 8.22644 18.1102Z"
        fill={color ?? "#149DFF"}
      />
      <path
        d="M11.3179 17.0498H10.5514V19.0028H9.99842V17.0498H9.23542V16.5212H11.3179V17.0498Z"
        fill={color ?? "#149DFF"}
      />
      <path
        d="M12.2133 19.0028H11.6533V16.5212H12.2133V19.0028Z"
        fill={color ?? "#149DFF"}
      />
      <path
        d="M13.1809 17.7603C13.1809 18.2783 13.5519 18.5093 13.8984 18.5093C14.2414 18.5093 14.6124 18.2783 14.6124 17.7603C14.6124 17.2423 14.2414 17.0077 13.8984 17.0077C13.5519 17.0077 13.1809 17.2423 13.1809 17.7603ZM12.6069 17.7638C12.6069 16.9762 13.1984 16.4688 13.8984 16.4688C14.5949 16.4688 15.1864 16.9762 15.1864 17.7638C15.1864 18.5477 14.5949 19.0553 13.8984 19.0553C13.1984 19.0553 12.6069 18.5477 12.6069 17.7638Z"
        fill={color ?? "#149DFF"}
      />
      <path
        d="M17.7365 19.0028H17.152L16.13 17.3718V19.0028H15.5805V16.5212H16.2525L17.1835 18.0297V16.5212H17.7365V19.0028Z"
        fill={color ?? "#149DFF"}
      />
    </svg>
  );
};

export default ImageCaptionIcon;
